<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     AP充值记录
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="mb-md">
    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item" style="width: 200px;">
          <el-input v-model="query.keyword" placeholder="订单号 / 主题" clearable prefix-icon="el-icon-search" @change="fetchData(1)" />
        </span>
      </div>
    </div>

    <el-card v-loading="listLoading" shadow="never">
      <el-table
        ref="orderTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          type="index"
          width="50" />
        <el-table-column
          label="订单号"
          min-width="140">
          <template slot-scope="scope">
            <el-link :underline="false" @click="$router.push('/expense/order/detail?orderid=' + scope.row.orderid)">{{ scope.row.order_sn }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="subject"
          label="主题"
          min-width="240" />
        <el-table-column
          label="订单生成时间"
          min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="金额"
          min-width="120">
          <template slot-scope="scope">
            <span class="font-lg">{{ scope.row.order_amount_total | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="order_status"
          label="订单状态"
          min-width="120" />
        <el-table-column
          label="操作"
          width="140">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope.row)">清单</el-button>
            <el-button v-if="scope.row.pay_status === 0" type="primary" size="mini" @click="$router.push('/expense/order/detail?orderid=' + scope.row.orderid)">去付款</el-button>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>

    <ap-order-detail v-if="detailDlgShow" :show.sync="detailDlgShow" :orderid="activeOrder.orderid" />
  </div>
</template>

<script>
import ApOrderDetail from './components/ApOrderDetail'
import { apOrderListApi } from '@/api/ap/apOrderApi'
export default {
  components: {
    ApOrderDetail
  },
  data() {
    return {
      query: {
        keyword: '',
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      listLoading: false,
      list: [],
      total: 0,

      detailDlgShow: false,
      activeOrder: {}
    }
  },
  created() {
    const keepAlivePath = [
      '/expense/order/detail'
    ]
    this.query = this.$utils.initListQuery(this.query, keepAlivePath)
    this.fetchData()
  },
  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query)
    next()
  },
  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page
      this.listLoading = true
      apOrderListApi(this.query).then(res => {
        this.listLoading = false
        if (res.errno === 0) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    showDetail(row) {
      this.activeOrder = Object.assign({}, row)
      this.detailDlgShow = true
    }
  }
}
</script>
